import React from 'react'
import { useScrollAnimation } from '../../hooks/useScrollAnimation'

const steps = [
  {
    number: '01',
    title: 'Create Your Account',
    description:
      'Sign up in minutes and get instant access to our capital gains calculator platform.',
  },
  {
    number: '02',
    title: 'Import Your Data',
    description: 'Upload your transaction history via CSV.',
  },
  {
    number: '03',
    title: 'Review Calculations',
    description:
      'Pick your the currency you want to convert your capital gains/losses to and our system automatically calculates them with precision.',
  },
]

const HowItWorksSection: React.FC = () => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.1 })

  return (
    <section id="how-it-works" className="py-20 bg-white">
      <div
        ref={ref}
        className="container mx-auto px-6"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(50px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
        }}>
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">How It Works</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Get started with your capital gains calculations in three simple steps
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="flex gap-6">
                  <div className="flex-shrink-0">
                    <div className="w-16 h-16 bg-[#2C2B69] text-white rounded-full flex items-center justify-center text-2xl font-bold">
                      {step.number}
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 mb-3">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 leading-relaxed">{step.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-[#2C2B69]/10 border-2 border-[#2C2B69] rounded-xl p-8 max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">
              Ready to simplify your capital gains tax reporting?
            </h3>
            <p className="text-gray-600 mb-6">
              Join thousands of investors who trust our platform for accurate capital
              gains calculations
            </p>
            <button
              onClick={() => (window.location.href = '/auth/signup')}
              className="px-8 py-4 bg-[#2C2B69] text-white rounded-lg hover:bg-[#2C2B69]/70 transition font-semibold text-lg shadow-lg">
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}

export default HowItWorksSection
